module.exports = __webpack_public_path__ + "media/images/favicon-2-e32e1a703c12d82ab9ff48ca1f797a5f.ico";